
export default {
  data() {
    return {
      inView: false,
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: ".swiper-news-next",
          prevEl: ".swiper-news-prev",
        },
        breakpoints: {
          767: {
            spaceBetween: 20,
            slidesPerView: 2,
          },
          1200: {
            spaceBetween: 40,
            slidesPerView: 3,
          },
        },
      },
    };
  },
};
